export const getClassName = level => {
  return "InfoSectionUnitTypeTree" + (level > 0 ? "__sublevel" : "");
};

export const getHasChildren = (unitTypes, unitId) => {
  return unitTypes.some(item => item.parentId === unitId);
};
